import { render, staticRenderFns } from "./TimesIcon.vue?vue&type=template&id=9c814712&"
import script from "./TimesIcon.vue?vue&type=script&lang=js&"
export * from "./TimesIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports